module.exports = __webpack_public_path__ + "static/img/mp2.7d2a62a.png";